/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".circle{border-radius:50%;display:flex;justify-content:center;align-items:center;position:relative;padding:10px 0}.circle .popup_user{cursor:default;position:absolute;left:0;background-color:#fff;padding:15px;border:1px solid #d6d6d6;border-radius:8px;z-index:99}.circle .popup_user.popup_top{bottom:25px}.circle .popup_user.popup_bottom{top:25px}.circle img{border-radius:50%}.circle .initials{color:#fff;font-size:12px;line-height:9px;letter-spacing:.2625px}"];
export { styles as styles };
